// Deposit address (manual transfer) flow with no source exchange: amount is optional
// and min/max limits are not used for validation, so the limits fetch can be skipped.
export function isDepositAddressFlow(depositMethod, fromExchange) {
    return depositMethod === 'deposit_address' && !fromExchange;
}
export function isDepositAddressSwap(swapData) {
    return !!swapData?.use_deposit_address && !swapData.source_exchange;
}
